import { createReducer } from 'typesafe-actions'
import { setFiats } from '../actions/fiat'
import { ActionTypes } from '../types'

export type FiatState = {
  data: string[]
}

export const initialState: FiatState = {
  data: [],
}

export const fiat = createReducer<FiatState, ActionTypes>(initialState).handleAction(
  setFiats,
  (state: FiatState, { payload }) => ({
    data: Array.from(new Set((payload || []).map((c) => (c || '').toUpperCase().trim()))),
  }),
)
